import React from 'react'

import Image from '~/components/core/Image'
import { ImageNew } from '~/components/core/ImageNew'

const HpHero = ({ data }) => {
  const chapo = data.heroText.heroText ? data.heroText.heroText : data.heroText

  return (
    <div className="min-h-[calc(100vh-35px)] pt-40 bg-center bg-cover md:min-h-[540px] md:pt-[12.5rem] pb-28 md:pb-32 text-white relative  ">
      <Image
        classes="hp-hero__pic"
        // width="1400"
        // height="540"
        // sizes={{ 415: [415, 670], 767: [767, 800], 1023: [1023, 540] }}
        // isTop={true}
        isBg={true}
        image={data.heroBackground}
      />

      <div className="fluid-grid">
        <div className="row text-center lg:text-left justify-center">
          <div className="col-12 md-col-8 lg:mr-0 lg-col-6 lg-col-offset-1 xl-col-5 ">
            <h1 className="hp-hero__title font-bold mb-8 lg:mb-0">
              {data.heroTitleLine1}
              <br />{' '}
              <span className="hp-hero__title-line hp-hero__title-line--blue">
                {data.heroTitleLine2}
              </span>
              <br />{' '}
              <span className="hp-hero__title-line hp-hero__title-line--purple">
                {data.heroTitleLine3}
              </span>
            </h1>
          </div>
          <div className="col-12 md-col-8  lg:mr-0 lg-col-3 lg-col-offset-1 xl-col-3 xl-col-offset-0">
            <p className="paragraph font-semi-bold">{chapo}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HpHero
